<template>
	<textarea class="type-textarea"
		rows="6"
        @blur="blur"
		:value="value"
		:class="_class"
		:placeholder="placeholder"
		@input="$emit('input', $event.target.value)">
	</textarea>
</template>

<script>
	export default {
		name: 'type-textarea',
		props: {
			value: null,
			placeholder: {
				type: String,
				default: '请输入内容'
			},
			whitebackdrop: {
				type: Boolean,
				default: false
			}
		},
        methods: {
			blur() {
				if (navigator.userAgent.toLocaleLowerCase().includes('iphone')) {
					window.scroll(0, 0);
				}
				this.$emit('blur', event.target.value);
			}
        },
		computed: {
			_class() {
				return this.whitebackdrop ? 'white-backdrop' : 'other-backdrop';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-textarea{
		width: calc(100% - 22px);
		height: calc(100% - 22px);
		padding: 10px 10px;
		border-radius: 0px;
		font-size: 19px;
		font-weight: 300;
		font-family: 'Montserrat', sans-serif;
		&:focus{
			outline: none;
			box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
		}
		&::-webkit-input-placeholder{
			font-size: 19px;
			font-weight: 300;
			font-family: 'Montserrat', sans-serif;
		}
		&::-ms-input-placeholder{
			font-size: 19px;
			font-weight: 300;
			font-family: 'Montserrat', sans-serif;
		}
		&::-moz-placeholder{
			font-size: 19px;
			font-weight: 300;
			font-family: 'Montserrat', sans-serif;
		}
	}
	.white-backdrop{
		color: #000000;
		background-color: rgba(255, 255, 255, 1);
		border: 1px solid rgba(136, 136, 136, 0.5);
		&::-webkit-input-placeholder{
			color: rgba(153, 153, 153, 1);
		}
		&::-ms-input-placeholder{
			color: rgba(153, 153, 153, 1);
		}
		&::-moz-placeholder{
			color: rgba(153, 153, 153, 1);
		}
	}
	.other-backdrop{
		color: #FFFFFF;
		background-color: rgba(0, 0, 0, 0.65);
		border: 1px solid rgba(255, 255, 255, 0.03);
		&::-webkit-input-placeholder{
			color: rgba(255, 255, 255, 0.8);
		}
		&::-ms-input-placeholder{
			color: rgba(255, 255, 255, 0.8);
		}
		&::-moz-placeholder{
			color: rgba(255, 255, 255, 0.8);
		}
	}
</style>
